/**
 * Objektrepresentation för en egenskap. <br> Om egenskaper saknas returernas en tom array. <br> Egenskaper returneras sorterade på i första hand attributet egenskapstyp_namn i alfabetiskt ordning fallande (A-Ö).<br> I andra hand sorterade på attributet egenskapsvarde_namn i alfabetiskt ordning fallande (A-Ö).
 */
export interface Egenskap {
  /**
   * Anger unik stabil identitet för egenskapstypen.
   */
  egenskapstyp_id: Egenskap.EgenskapstypIdEnum;
  /**
   * Anger namnet för angiven egenskapstyp (lämpligt för presentation).
   */
  egenskapstyp_namn: string;
  /**
   * Anger unik stabil identitet för egenskapsvärdet.
   */
  egenskapsvarde_id: number;
  /**
   * Anger namnet för angivet egenskapsvärde (lämpligt för presentation).
   */
  egenskapsvarde_namn: string;
}
export namespace Egenskap {
  export type EgenskapstypIdEnum = 'FASADMATERIAL' | 'STOMME' | 'TAKFORM' | 'TAKTACKNINGSMATERIAL';
  export const EgenskapstypIdEnum = {
    FASADMATERIAL: 'FASADMATERIAL' as EgenskapstypIdEnum,
    STOMME: 'STOMME' as EgenskapstypIdEnum,
    TAKFORM: 'TAKFORM' as EgenskapstypIdEnum,
    TAKTACKNINGSMATERIAL: 'TAKTACKNINGSMATERIAL' as EgenskapstypIdEnum
  };
}
